'use strict';

var collapseWhiteSpace = require('collapse-white-space');

module.exports = normalize;

/* Normalize an identifier.  Collapses multiple white space
 * characters into a single space, and removes casing. */
function normalize(value) {
  return collapseWhiteSpace(value).toLowerCase();
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/util/normalize.js
// module id = 108
// module chunks = 0